/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.8.0-nightly.2026.10.9",
    versionName: "0.8.0-nightly.2026.10.9",
    versionChannel: "nightly",
    buildDate: "2026-10-09T00:19:34.016Z",
    commitHash: "fbb4ce889bc74928961a0a0ed0a84bb495e3830e",
};
